import { debounce } from 'debounce';

const delayedCallback = debounce(function(event, setFilter) {
  if (event && event.target && event.target.value) {
    setFilter(event.target.value.toLowerCase());
  }
}, 200);

export default delayedCallback;
